import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f24ac9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "设备号", -1));
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "创建人", -1));
const _hoisted_8 = {
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "创建时间", -1));
const _hoisted_10 = {
  class: "btn-content"
};
import dayjs from 'dayjs';
import { dateFormat } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlackFilterBlock',
  emits: ['filterSubmit'],
  setup(__props, {
    emit
  }) {
    const deviceId = ref('');
    const userName = ref('');
    const timeArr = ref([]);
    const filterSubmit = () => {
      var _timeArr$value;
      let params = {
        deviceId: deviceId.value,
        userName: userName.value
      };
      if (((_timeArr$value = timeArr.value) === null || _timeArr$value === void 0 ? void 0 : _timeArr$value.length) > 0) {
        params['startTime'] = dayjs(timeArr.value[0]).format(dateFormat);
        params['endTime'] = dayjs(timeArr.value[1]).format(dateFormat);
      }
      emit('filterSubmit', params);
    };
    const init = () => {
      deviceId.value = '';
      userName.value = '';
      timeArr.value = [];
      filterSubmit();
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_input, {
        placeholder: "请输入",
        value: deviceId.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => deviceId.value = $event),
        valueModifiers: {
          trim: true
        }
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_input, {
        placeholder: "请输入",
        value: userName.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => userName.value = $event),
        valueModifiers: {
          trim: true
        }
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_range_picker, {
        value: timeArr.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => timeArr.value = $event)
      }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});